import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  getReport: function (parameters) {
    return axios.get('/api/analytics/ras/report', {params: parameters});
  },
  exportReport: function(parameters) {
    return Utils.downloadFile('/api/analytics/ras/exportreport', "ReportRas.xlsx", parameters);
  },
  getReportFields: function() {
    return axios.get('/api/analytics/ras/fields');
  }
}